import { render, staticRenderFns } from "./MapContinent.vue?vue&type=template&id=2a9603e4&scoped=true&"
import script from "./MapContinent.vue?vue&type=script&lang=js&"
export * from "./MapContinent.vue?vue&type=script&lang=js&"
import style0 from "./MapContinent.vue?vue&type=style&index=0&id=2a9603e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9603e4",
  null
  
)

export default component.exports